import * as React from "react";
import { Accounts } from "@/new-pages/accounts";
import { UserManagement } from "@/new-pages/accounts/user-management";
import { Agents } from "@/new-pages/agents";
import { CreateAgent } from "@/new-pages/agents/create";
import { CallLogs } from "@/new-pages/call-logs";
import { CampaignBriefs } from "@/new-pages/campaign-briefs";
import { NewCampaignRequest } from "@/new-pages/campaign-briefs/new-request";
import { CampaignBriefView } from "@/new-pages/campaign-briefs/view";
import { Campaigns } from "@/new-pages/campaigns";
import { CreateCampaign } from "@/new-pages/campaigns/create";
import { CampaignView } from "@/new-pages/campaigns/view";
import { LeadView } from "@/new-pages/campaigns/view/lead-list/view";
import { ClientRequests } from "@/new-pages/client-requests";
import { ClientRequestView } from "@/new-pages/client-requests/view";
import { Contacts } from "@/new-pages/contacts";
import { Fields } from "@/new-pages/contacts/fields";
import { FindLeads } from "@/new-pages/contacts/find-leads";
import { Groups } from "@/new-pages/contacts/groups";
import { ContactView } from "@/new-pages/contacts/view";
// Import all components directly instead of using dynamic imports
import { Dashboard } from "@/new-pages/dashboard";
import { Personas } from "@/new-pages/personas";
import { CreatePersona } from "@/new-pages/personas/create";
import { PhoneNumbers } from "@/new-pages/phoneNumbers";
import { Plugins } from "@/new-pages/plugins";
import { Services } from "@/new-pages/plugins/services";
import { ProvingGroundRuns } from "@/new-pages/proving-ground/runs";
import { ProvingGroundRunView } from "@/new-pages/proving-ground/runs/view";
import { ProvingGroundScenarios } from "@/new-pages/proving-ground/scenarios";
import { ProvingGroundScorecard } from "@/new-pages/proving-ground/scorecard";
import { ProvingGroundSettingsPage } from "@/new-pages/proving-ground/settings";
import { RateCard } from "@/new-pages/rate-card";
import { DoNotCall } from "@/new-pages/settings/do-not-call";
import { TwoFactorSettings } from "@/new-pages/settings/two-factor";
import { WebsiteIntake } from "@/new-pages/settings/website-intake";
import { WebsiteIntakeRequests } from "@/new-pages/settings/website-intake/requests";
import { SystemLogs } from "@/new-pages/systemLogs";
import { Users } from "@/new-pages/users";
import { Outlet } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

import { AuthGuard } from "@/components/auth/auth-guard";
import { Layout as DashboardLayout } from "@/components/dashboard/layout/layout";

export const route: RouteObject = {
	element: (
		<AuthGuard>
			<DashboardLayout>
				<Outlet />
			</DashboardLayout>
		</AuthGuard>
	),
	children: [
		{
			index: true,
			Component: Dashboard,
		},
		{
			path: "accounts",
			Component: Accounts,
		},
		{
			path: "accounts/:accountId/users",
			Component: UserManagement,
		},
		{
			path: "user-management",
			Component: UserManagement,
		},
		{
			path: "users",
			Component: Users,
		},
		{
			path: "agents",
			Component: Agents,
		},
		{
			path: "agents/create",
			Component: CreateAgent,
		},
		{
			path: "agents/:agentId",
			Component: CreateAgent,
		},
		{
			path: "personas",
			Component: Personas,
		},
		{
			path: "personas/create",
			Component: CreatePersona,
		},
		{
			path: "personas/:personaId",
			Component: CreatePersona,
		},
		{
			path: "proving-ground/runs",
			Component: ProvingGroundRuns,
		},
		{
			path: "proving-ground/runs/:runId",
			Component: ProvingGroundRunView,
		},
		{
			path: "proving-ground/scenarios",
			Component: ProvingGroundScenarios,
		},
		{
			path: "proving-ground/scorecard",
			Component: ProvingGroundScorecard,
		},
		{
			path: "proving-ground/settings",
			Component: ProvingGroundSettingsPage,
		},
		{
			path: "contacts",
			Component: Contacts,
		},
		{
			path: "contacts/:contactId/view",
			Component: ContactView,
		},
		{
			path: "contacts/fields",
			Component: Fields,
		},
		{
			path: "contacts/groups",
			Component: Groups,
		},
		{
			path: "contacts/find-leads",
			Component: FindLeads,
		},
		{
			path: "phone-numbers",
			Component: PhoneNumbers,
		},
		{
			path: "call-logs",
			Component: CallLogs,
		},
		{
			path: "campaigns",
			Component: Campaigns,
		},
		{
			path: "campaigns/:campaignId",
			Component: CreateCampaign,
		},
		{
			path: "campaigns/create",
			Component: CreateCampaign,
		},
		{
			path: "campaigns/:campaignId/view",
			Component: CampaignView,
		},
		{
			path: "campaigns/:campaignId/contacts/:leadId/view",
			Component: LeadView,
		},
		{
			path: "campaign-briefs",
			Component: CampaignBriefs,
		},
		{
			path: "campaign-briefs/new",
			Component: NewCampaignRequest,
		},
		{
			path: "campaign-briefs/:briefId",
			Component: CampaignBriefView,
		},
		{
			path: "client-requests",
			Component: ClientRequests,
		},
		{
			path: "client-requests/:briefId",
			Component: ClientRequestView,
		},
		{
			path: "rate-card",
			Component: RateCard,
		},
		{
			path: "plugins",
			Component: Plugins,
		},
		{
			path: "plugins/services",
			Component: Services,
		},
		{
			path: "system-logs",
			Component: SystemLogs,
		},
		{
			path: "settings/two-factor",
			Component: TwoFactorSettings,
		},
		{
			path: "settings/do-not-call",
			Component: DoNotCall,
		},
		{
			path: "settings/website-intake",
			Component: WebsiteIntake,
		},
		{
			path: "settings/website-intake/requests",
			Component: WebsiteIntakeRequests,
		},
	],
};
